import AuthService from "../service/auth-service";

//登入流程編排
//
//  把「拿到 Google ID Token → 後端驗證建帳號 → 存本地 profile」收在一起。
//  散在各元件會出現只做了前兩步、忘了廣播的版本，導致 nav 不會更新。
//
//  取得 ID Token 那一步在 utils/google-identity.js（Google 官方按鈕的 callback），
//  這裡只負責拿到 token 之後的事。
//
//  帳號本體由後端以 userEmail 為唯一鍵建立、並產生 userID（見 routes/auth-route.js）。

//後端建帳號時 userValidCode 預設是 "1"（尚未填完基本資料）。
//  Google 已經給了名字，就直接用它把註冊補完，讓人登入後馬上能用；
//  生日、性別等命理必需的資料，等真正要用到的服務再引導補齊。
const completeRegisterIfNeeded = async (user) => {
  if (!user || user.userValidCode !== "1") return user;

  const name = user.userName?.trim();
  if (!name) return user; //連名字都沒有 → 留給註冊頁處理，不亂填

  try {
    const res = await AuthService.registerFull({ userName: name });
    return res.data?.data?.user || user;
  } catch (e) {
    //補完失敗不該讓整個登入失敗：帳號已經建好了，之後仍可補
    console.warn("[Auth] 自動補完註冊失敗:", e.message);
    return user;
  }
};

//用 Google ID Token 完成登入
//  credential：Google 官方按鈕 callback 給的 ID Token
//  成功回傳 user，失敗 throw（由呼叫端決定怎麼顯示錯誤）
export const signInWithGoogleCredential = async (credential) => {
  const res = await AuthService.googleLogin(credential);

  if (!res.data?.status) {
    throw new Error(res.data?.message || "登入失敗");
  }

  const user = await completeRegisterIfNeeded(res.data.data.user);

  //存 profile 並廣播 user-updated，讓 nav 等已 mount 的元件同步
  AuthService.login(user);
  return user;
};

//把錯誤翻成看得懂的中文
//  直接把 axios 或 Google 的原始訊息丟給使用者沒有意義
export const describeAuthError = (e) => {
  //後端明確回的訊息優先（例如「Google 登入驗證失敗」）
  const apiMessage = e?.response?.data?.message;
  if (apiMessage) return apiMessage;

  if (e?.response?.status === 429) {
    return "登入嘗試過於頻繁，請稍後再試";
  }
  //axios 連不到後端
  if (e?.code === "ERR_NETWORK") {
    return "無法連線到伺服器，請確認網路後再試一次";
  }
  return e?.message || "登入失敗，請稍後再試";
};
